export default "__VITE_ASSET__JdeVI1gJ__"